import { Column } from "components/styles";
import styled from "styled-components";

export const Container = styled(Column)`
    max-height: 75vh;
	padding: 0 20px;
`;